/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFaxReadStatusRequest
 */
export interface UpdateFaxReadStatusRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFaxReadStatusRequest
     */
    is_read: boolean;
}

/**
 * Check if a given object implements the UpdateFaxReadStatusRequest interface.
 */
export function instanceOfUpdateFaxReadStatusRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_read" in value;

    return isInstance;
}

export function UpdateFaxReadStatusRequestFromJSON(json: any): UpdateFaxReadStatusRequest {
    return UpdateFaxReadStatusRequestFromJSONTyped(json, false);
}

export function UpdateFaxReadStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFaxReadStatusRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'is_read': json['is_read'],
    };
}

export function UpdateFaxReadStatusRequestToJSON(value?: UpdateFaxReadStatusRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_read': value.is_read,
    };
}

